/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Dont_Show_AgainInputs */

const es_chat_edit_dont_show_again = /** @type {(inputs: Chat_Edit_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No volver a mostrar`)
};

const en_chat_edit_dont_show_again = /** @type {(inputs: Chat_Edit_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't show again`)
};

/**
* | output |
* | --- |
* | "Don't show again" |
*
* @param {Chat_Edit_Dont_Show_AgainInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_edit_dont_show_again = /** @type {((inputs?: Chat_Edit_Dont_Show_AgainInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Dont_Show_AgainInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_edit_dont_show_again(inputs)
	return en_chat_edit_dont_show_again(inputs)
});
export { chat_edit_dont_show_again as "chat.edit.dont_show_again" }